import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useReporter } from '../../reporter';
import { ProductSelectionForm } from '../ProductSelectionForm';
import { ApiResult } from '../../api';
import { useSessionCustomer } from '../../customer';
import { formatPrice } from '../../format';
import { userViewMealPrepScreen, userUpdatesMealPrep } from './events';

export const PlanTypeSelectionForm = ({
  onSubmit,
  headline,
  subheadline,
  ctaText,
  productTypes,
  defaultProductType,
  unavailableProductTypes = [],
  amount,
  discountedAmount,
  returnToQuiz,
  period = '',
  legend = '',
}) => {
  const reporter = useReporter();
  const [selectedProductType, setSelectedProductType] = useState(
    defaultProductType,
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { customer, isLoading: isCustomerLoading } = useSessionCustomer();

  useEffect(() => {
    if (!isCustomerLoading) {
      reporter.tag(
        userViewMealPrepScreen({
          customer_info: {
            email: customer.email,
          },
        }),
      );
    }
  }, [reporter, isCustomerLoading, customer]);

  const onChange = product => {
    setSelectedProductType(product[0]);
  };

  const onSubmitHandler = async event => {
    event.preventDefault();
    setIsSubmitting(true);
    reporter.tag(userUpdatesMealPrep(selectedProductType));
    const submitResult = await onSubmit(selectedProductType);
    ApiResult.ifError(submitResult, () => setIsSubmitting(false));
  };

  const checkoutBarProps = {
    amount: amount ? formatPrice(amount) : '',
    ctaText,
    disabled: isSubmitting,
    discountedAmount: discountedAmount ? formatPrice(discountedAmount) : '',
    period,
    shown: true,
    onBackButtonClick: returnToQuiz,
  };

  const productSelectorProps = {
    products: productTypes.map(productType => ({
      ...productType,
      shouldShowMoreDetails: false,
      inputType: 'radio',
    })),
    selected: [selectedProductType],
    unavailableProducts: unavailableProductTypes,
    variant: 'radio',
  };

  return (
    <>
      <ProductSelectionForm
        checkoutBar={checkoutBarProps}
        headline={headline}
        legend={legend}
        onChange={onChange}
        onSubmit={onSubmitHandler}
        productSelector={productSelectorProps}
        subheadline={subheadline}
      />
    </>
  );
};
PlanTypeSelectionForm.displayName = 'PlanTypeSelectionForm';
PlanTypeSelectionForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  headline: PropTypes.string.isRequired,
  subheadline: PropTypes.node.isRequired,
  ctaText: PropTypes.string.isRequired,
  unavailableProductTypes: PropTypes.array,
  productTypes: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      description: PropTypes.node.isRequired,
      img: PropTypes.any,
      pricingInfo: PropTypes.shape({
        discount: PropTypes.string.isRequired,
        price: PropTypes.string.isRequired,
      }),
      benefit: PropTypes.string,
    }).isRequired,
  ).isRequired,
  defaultProductType: PropTypes.string,
  amount: PropTypes.number,
  discountedAmount: PropTypes.number,
  returnToQuiz: PropTypes.func.isRequired,
  period: PropTypes.string,
  legend: PropTypes.string,
};
